import { render } from "./StackField.vue?vue&type=template&id=77e7e4ad"
import script from "./StackField.vue?vue&type=script&lang=js"
export * from "./StackField.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"StackField.vue"]])

export default __exports__